<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-22 15:30:50
 * @LastEditors: lau
 * @LastEditTime: 2022-08-23 13:44:07
-->
<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-22 09:10:08
 * @LastEditors: lau
 * @LastEditTime: 2022-08-22 09:15:38
-->

<!-- 根据根据券模版代码查询券模版信息接口内容 -->
<template>
	<div class="">
		<right-structure :Pdatas='infoData'>
			<pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
			<pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
		</right-structure>
	</div>
</template>

<script>
	import structure from "@/components/commonStructure"

	export default {
		name: '',
		components: {
			'right-structure': structure,
		},
		props: ['commonUrls'],
		data() {
			return {
				requestBody: {
					"couponCode":""
				},
				responseCode: {
					"data": {
					},
					"message": "业务成功",
					"resultCode": 0,
					"status": 1
				},
				infoData: {
					explain: "第三方接入系统请求智慧停车开放平台查询电子券打印记录",
					t_url: this.commonUrls.test + "queryCouponPrintRecord",
					p_url: this.commonUrls.prod + "queryCouponPrintRecord",
					precondition: "无",
					fitSystem: "VEMS传统停车场，云停车场",
					pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
					Q_params: [{
						titleName: null,
						tabledata: [{tableHead: '参数名',tdName: 'info1'}, {tableHead: '是否必填',tdName: 'info2'}, {tableHead: '类型',tdName: 'info3'}, {tableHead: '说明',tdName: 'info4'}],
						td: [
							{info1: 'couponCode',info2: '是',info3: 'String',info4: '优惠券编码'},

					 ]
					}],
					R_params: [{
						titleName: null,
						tabledata: [{tableHead: '参数名',tdName: 'info1'}, {tableHead: '是否必填',tdName: 'info2'}, {tableHead: '类型',tdName: 'info3'}, {tableHead: '说明',tdName: 'info4'}],
						td: [ 
									{ info1: 'sellBillId', info2: '是', info3: 'Long', info4: '优惠券售卖流水id' },
                  { info1: 'couponTmpId', info2: '是', info3: 'Long', info4: '券模板id' },
                  { info1: 'serialNumber', info2: '是', info3: 'String', info4: '券编码' },
                  { info1: 'traderId', info2: '是', info3: 'Long', info4: '商户id' },
                  { info1: 'printTime', info2: '是', info3: 'String', info4: '打印时间yyyyMMddHHmmss' },
                  { info1: 'isCancel', info2: '是', info3: 'Integer', info4: '是否取消(0否,1是)' },
                  { info1: 'validFrom', info2: '是', info3: 'String', info4: '有效期开始时间yyyyMMddHHmmss' },
                  { info1: 'validTo', info2: '是', info3: 'String', info4: '有效期截止时间yyyyMMddHHmmss' },

						]
					}],
					codeStatus: [{
						titleName: null,
						tabledata: [{
							tableHead: '状态码',
							tdName: 'info1'
						}, {
							tableHead: '说明',
							tdName: 'info2'
						}],
						td: [{
							info1: '000110',
							info2: '失败',
						}, {
							info1: '00110000',
							info2: '失败',
						}, {
							info1: '110000',
							info2: '失败',
						}]
					}],
				}
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/coupon/queryCouponPrintRecord.vue